import React from 'react'
import PropTypes from 'prop-types'
import { Button, useTheme } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const PanelButton = ({ showPanel, onClick }) => {
  const theme = useTheme()

  return (
    <Button
      variant="text"
      onClick={onClick}
      sx={{
        position: 'fixed',
        top: '50%',
        minWidth: 16,
        width: 16,
        height: 48,
        bgcolor: 'primary.main',
        color: theme.palette.common.white,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        zIndex: theme.zIndex.drawer,
      }}
    >
      {showPanel ? <ChevronLeft /> : <ChevronRight />}
    </Button>
  )
}

PanelButton.propTypes = {
  showPanel: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default PanelButton
